var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 338.044,
    height: 343.353,
    viewBox: "0 0 338.044 343.353",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1175",
    "data-name": "Group 1175",
    transform: "translate(-1661.357 -0.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M145.1,8.828,358.975,3.84,269.367,148.919,54.289,154.156Z",
    transform: "matrix(0.848, -0.53, 0.53, 0.848, 1613.282, 187.545)",
    fill: "#fff",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M99.444,6.32,205.791,3.84,161.234,75.979l-106.945,2.6Z",
    transform: "matrix(0.848, -0.53, 0.53, 0.848, 1614.448, 306.054)",
    fill: "#fff",
    opacity: 0.05
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape3);
export default __webpack_public_path__ + "static/media/shape-3.4e93cb41d096665d0ac367ed8074949e.svg";
export { ForwardRef as ReactComponent };